/**
 * Created by tomers on 2/28/2017.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var CONST = require("const");
    var ApiKeysListLayout = require("manager-views/data-sources/api-keys/ApiKeysListLayout");
    var ApiKeysGalleryView = require("manager-views/data-sources/api-keys/ApiKeysGalleryView");
    var ApiDevelopersCommunityView = require("manager-views/data-sources/api-keys/ApiDevelopersCommunityView");

    var ApiKeysListController = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        ApiKeysListController = Marionette.Controller.extend({
            apiKeysListLayout: null,

            initialize: function(options) {
                this._initialize(options);
            },
            getView: function() {
                return this._getView();
            },

            _initialize: function(options) {
                this.channel = LEManager.media.channel("apiKeys");
                this._bindEvents();
            },

            _bindEvents: function() {
                this.listenTo(this.channel, "apiKeys:create", this._onApiKeysCreate);
                this.listenTo(this.channel, "apiKeys:edit", this._onApiKeysEdit);
            },

            _getView: function() {
                this._initData();
                this._initViews();
                return this.apiKeysListLayout;
            },

            _initData: function() {

            },

            _initViews: function() {
                this.apiKeysListLayout = new ApiKeysListLayout();
                this.listenToOnce(this.apiKeysListLayout, "render", this._onApiLeysListLayoutRender);
            },

            _onApiLeysListLayoutRender: function() {
                var apiKeysGalleryView = new ApiKeysGalleryView();
                var apiDevelopersCommunityView = new ApiDevelopersCommunityView();

                this.apiKeysListLayout.apiKeysGallery.show(apiKeysGalleryView);
                this.apiKeysListLayout.apiDevelopersCommunity.show(apiDevelopersCommunityView);
            },

            _onApiKeysCreate: function() {
                this._routeToApiKeyEdit(CONST.ROUTING.NEW_ITEM_ID);
            },

            _onApiKeysEdit: function(itemId) {
                this._routeToApiKeyEdit(itemId);
            },

            _routeToApiKeyEdit: function(itemId) {
                var currentRoute = LE.context.get("navigationCurrent.route");
                var itemRoute = currentRoute + "/" + itemId;
                LEManager.router.navigate(itemRoute);
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    return ApiKeysListController;
});
